export const USER_TYPES = {
    TPRO_AGENCY_ADMIN: 'TPAgencyAdmin',
    TPRO_INTERNAL_ADMIN: 'TPInternalAdmin',
    TPRO_AGENCY_AGENT: 'TPAgencyAgent',
    TPRO_AGENCY_CLIENT: 'TPAgencyClient',
    TPRO_AGENCY_VIEWER: 'TPAgencyViewer'
  };